function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { createAppsPricingDataReceivedAction } from '@shared/actions/actions';
import * as catalogApiRestClient from '@shared/services/http/catalogApiRestClient';
import { parseCatalogStartingPrice } from './appUtils';
import { stringifyError } from './errorUtils';
import { getWindow } from '@shared/services/window';
import { Constants } from './constants';
import { logger } from '@src/logger';
export function fetchPricingAction({ countryCode, apps = [] }) {
    return (dispatch, getState)=>_async_to_generator(function*() {
            try {
                const { flightCodes, startingPricingData, includeTestProducts } = getState().config;
                const filteredApps = apps.filter(({ entityId })=>!(startingPricingData === null || startingPricingData === void 0 ? void 0 : startingPricingData[`${entityId}`]));
                if (!filteredApps.length) {
                    return;
                }
                const catalogStartingPrices = yield catalogApiRestClient.getProductsPricing({
                    productsBigIds: filteredApps.map(({ bigId })=>bigId),
                    market: countryCode,
                    hideKey: flightCodes,
                    includeTestProducts
                });
                const startingPrices = filteredApps.reduce((startingPrices, viewApp)=>{
                    startingPrices[viewApp.entityId] = parseCatalogStartingPrice({
                        catalogStartingPrice: catalogStartingPrices.items.find(({ legacyId })=>legacyId === viewApp.entityId),
                        appData: viewApp
                    });
                    return startingPrices;
                }, {});
                const pricingPayload = {
                    pricingData: startingPrices,
                    countryCode
                };
                dispatch(createAppsPricingDataReceivedAction(pricingPayload));
                return startingPrices;
            } catch (error) {
                const errorString = stringifyError(error);
                const payload = {
                    page: getWindow().location.href,
                    action: Constants.Telemetry.Action.Error,
                    actionModifier: Constants.Telemetry.ActionModifier.FetchPricing,
                    details: JSON.stringify({
                        error: errorString,
                        countryCode,
                        apps: apps.map(({ entityId })=>({
                                entityId
                            }))
                    })
                };
                logger.error(payload.details, {
                    action: payload.action,
                    actionModifier: payload.actionModifier
                });
            }
        })();
}
